import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "card" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", {
    class: "card-body",
    style: { "background-color": "#fdf7f7" }
}, [
    /*#__PURE__*/ _createTextVNode("\r\n\t\t\tPassword must:\r\n\t\t\t"),
    /*#__PURE__*/ _createElementVNode("ul", { class: "mb-0" }, [
        /*#__PURE__*/ _createElementVNode("li", null, "\r\n\t\t\t\t\tContain a number\r\n\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("li", null, "\r\n\t\t\t\t\tContain an uppercase letter\r\n\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("li", null, "\r\n\t\t\t\t\tContain a lowercase letter\r\n\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("li", null, "\r\n\t\t\t\t\tContain a special character (!@#$%^&*)\r\n\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("li", null, "\r\n\t\t\t\t\tBe at least 12 characters long\r\n\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_3 = [
    _hoisted_2
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3));
}
